import { defineComponent as _defineComponent } from 'vue'
import { useEditorialTracking } from '@/features/editorial/tracking';

import type { Maybe } from '@/helpers/types';

import ProfileBox from '@/features/user-profile/components/ProfileBox.vue';

import { faFacebook, faInstagram, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { faLink, faExternalLinkAlt, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { socialLinkTypes } from '@/features/user-profile/types';

import { useUserProfile } from '@/features/user-profile/composables/useUserProfile';
import { computed } from 'vue';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserDetails',
  setup(__props) {

const { trackEditorial } = useEditorialTracking();

const ICONS = {
	twitter: faTwitter,
	facebook: faFacebook,
	instagram: faInstagram,
	linkedin: faLinkedin,
	link: faLink,
} as Record<any, IconDefinition>;

const { profile, setView } = useUserProfile();

const socials = computed(() => (profile.value?.externalUrls ?? []).filter(url => url.type !== 'WEBSITE'));

const publications = computed(() => (profile.value?.externalUrls ?? []).filter(url => url.type === 'WEBSITE'));

function toHostname(url: string) {
	try {
		return new URL(url).hostname;
	} catch {
		return null;
	}
}

async function handleClick(name: Maybe<string>, url: string) {
	await trackExternalLinkClick(name, url);
	window.location.href = url;
}

async function trackExternalLinkClick(name: Maybe<string>, url: string) {
	trackEditorial('clickOnAuthorLinks', {
		spec: { category: 'person_social_media', property: name ?? url },
	});
}

return { __sfc: true,trackEditorial, ICONS, profile, setView, socials, publications, toHostname, handleClick, trackExternalLinkClick, ProfileBox, faLink, faExternalLinkAlt, faPencilAlt, socialLinkTypes, faChevronDown }
}

})